module.exports = __webpack_public_path__ + "img/workout.b8bc4fea.png";